<div class="boxContainer configuracoesList_item">
  <div class="d-flex align-items-baseline">
    <img [src]="iconPath" alt="{{ pageTitle }}" />
    <h2 class="boxContainer_titulo ml-3">{{ pageTitle }}</h2>
  </div>
  <div class="box-exclusivo-morador">
    <div class="filtro-exclusivo-morador">
      <a href="#">
        Mostrar
      </a>
    </div>
  </div>
  <div class="botoes-exclusivo-morador">
    <div class="botoes-data">
      <button class="{{ getButtonClass('todos') }}" (click)="showAllItems()">
        Todos
      </button>
      <button class="{{ getButtonClass('online') }}" (click)="showOnlineItems()">
        Online
      </button>
      <button class="{{ getButtonClass('presencial') }}" (click)="showPresencialItems()">
        Presencial
      </button>
    </div>
  </div>

  <!-- Educação -->
  <!-- <div class="filter_container d-flex" *ngIf="pageTitle === 'Educação'">
    <div class="filter_item_container p-10 d-flex flex-column justify-content-between" *ngIf="showFilterItems">
      <form>
        <a class="filter_item" (click)="showAdditionalItems()">
          <label for="c1" class="mr-3">Inscrever estudante</label>
        </a>
        <a href="#" class="filter_item">
          <label for="c2">Consultar calendário</label>
        </a>
        <a href="#" class="filter_item">
          <label for="c3">Consultar frequência do estudante</label>
        </a>
        <a href="#" class="filter_item">
          <label for="c3">Consultar boletim do estudante</label>
        </a>
        <a href="#" class="filter_item">
          <label for="c3">Consultar alimentação escolar</label>
        </a>
        <a href="#" class="filter_item">
          <label for="c3">Solicitar transferência do estudante</label>
        </a>
      </form>
    </div>

    <div class="filter-todos_item_container p-10 d-flex flex-column justify-content-between"
      *ngIf="showAdditionalFilterItems">
      <form>  
        <a href="#" class="filter-todos_item">
          <label for="c4" class="mr-3">Legislação</label>
        </a>
        <a href="#" class="filter-todos_item">
          <label for="c5">Informação sobre o decreto, lei ou portaria no qual se baseia o serviço</label>
        </a>
        <a href="#" class="filter-todos_item">
          <label for="c6">Quem pode solicitar</label>
        </a>
        <a href="#" class="filter-todos_item">
          <label for="c7">Requisitos necessários</label>
        </a>
        <a href="#" class="filter-todos_item">
          <label for="c8">Documentos</label>
        </a>
        <a href="#" class="filter-todos_item">
          <label for="c9">Etapas do serviço</label>
        </a>
      </form>
    </div>
  </div> -->

  <!-- Benefícios -->
  <div class="filter_container d-flex" *ngIf="pageTitle === 'Benefícios'">
    <div class="filter_item_container p-10" *ngIf="showFilterItems">
      <form>
        <a class="filter_item" (click)="showAdditionalItems()">
          <label for="c1" class="mr-3">Solicitar auxílio leite</label>
        </a>
        <hr>
        <a href="#" class="filter_item">
          <label for="c2">Solicitar auxílio maternidade</label>
        </a>
        <hr>
        <a href="#" class="filter_item">
          <label for="c3">Solicitar transporte escolar</label>
        </a>
        <hr>
        <a href="#" class="filter_item">
          <label for="c3">Consultar benefícios ativos</label>
        </a>
      </form>
    </div>

    <div class="filter-todos_item_container p-10 d-flex flex-column justify-content-between"
      *ngIf="showAdditionalFilterItems">
      <form>  
        <div *ngIf="this.showSolicitarServico" class="col-3 pl-3 btn-solicitar-servico">
          <div>
          </div>
          <div>
          <!-- <button class=" {{ getButtonClass('todos') }}" (click)="showAllItems()">
            <i class="mr-1 fa-solid fa-bell"></i>
            Solicitar serviço
          </button> -->
          </div>
        </div>
        <div class="info-container d-flex flex-column align-items-start">
          <div class="info-item">
            <h3>Título do serviço</h3>
            <p>Nome do serviço oferecido</p>
          </div>
          <div class="info-item">
            <h3>Descrição</h3>
            <p>Breve descrição do serviço</p>
          </div>
          <div class="info-item">
            <h3>Legislação</h3>
            <p>Informação sobre o decreto, lei ou portaria no qual se baseia o serviço</p>
          </div>
          <div class="info-item">
            <h3>Quem pode solicitar</h3>
            <p>Requisitos necessários para pessoa física ou jurídica</p>
          </div>
          <div class="info-item">
            <h3>Documentos</h3>
            <p>Descrição sobre os requisitos para pedir o serviço</p>
          </div>
          <div class="info-item">
            <h3>Etapas do serviço</h3>
            <p>Lista de documentos necessários para solicitação do serviço</p>
          </div>
          <div class="info-item">
            <h3>Prazo para conclusão</h3>
            <p>Informação sobre as etapas da prestação do serviço e prazo máximo para finalização do serviço</p>
          </div>
          <div class="info-item">
            <h3>Taxa</h3>
            <p>Se houver, informar o tipo de taxa e o valor</p>
          </div>
          <div class="info-item">
            <h3>Órgão responsável</h3>
            <p>Informações sobre secretaria ou departamento que presta o serviço</p>
          </div>
          <div class="info-item">
            <h3>Data da publicação</h3>
            <p>XX.XX.XXXX</p>
          </div>
          <div class="info-item">
            <h3>Data da vigência</h3>
            <p>Até XX.XX.XXXX</p>
          </div>
        </div>
        
      </form>
    </div>
  </div>
</div>